import { storageInfo } from '../../../utils/storageUtils';
import {
  AUTH_LOGIN_OK,
  UPDATE_UNREAD_NUMBER,
  INIT_USERINFO_FROM_LOCAL,
  AUTH_UPDATE_USER_INFO,
} from '../../action-types';
import { loginApi } from '../../../api/auth';
import { toast } from 'react-toastify';
import { history } from "../../../history";

//处理登录请求
export const loginAction = ({email, password,t}) => {
  return (dispatch) => {
    loginApi({
      email,
      password,
    }).then((response) => {
      if (response) {
        if(response===10003){
          toast.error(t("error_10003_nolover"), {
            autoClose: 1000,
          })
        }else if(response===10004){
          toast.error(t("error_10004_wrong_password"), {
            autoClose: 1000,
          })
        }else {
          //在本地保存用户信息
          // console.log("在本地保存用户信息:",response.loginLover.token);
          storageInfo.saveToken(response.token);
          // console.log('response.loginLover',response.loginLover)
          storageInfo.saveUserInfo(response.loginLover);
          dispatch({
            type: AUTH_LOGIN_OK,
            payload: response,
          });
          history.replace('/')
        }
      }
    });
  };
};

//从本地缓存中初始化用户信息到redux
export const initUserInfo = (userInfo) => {
  //还需要api请求判断用户信息是否有效
  return (dispatch) => {
    dispatch({
      type: INIT_USERINFO_FROM_LOCAL,
      payload: userInfo,
    });

  };
};

//处理登录请求
// export const loginAction = ({ email, password }) => {
//   // console.log('loginAction', username, password);
//   return (dispatch) => {
//     console.log('reducer receive response', email);
//     loginApi({
//       email,
//       password,
//     }).then((response) => {
      
//       if (response) {
//         //在本地保存用户信息
//         dispatch({
//           type: AUTH_LOGIN_OK, //动作
//           payload: response, //数据
//         });
//       }
//     });
//   };
// };




//处理退出登录
export const logoutAction = () => {
  // return (dispatch) => {
  //   storageUserInfo.delUserInfo();
  //   storageUserInfo.delMoneyInfo();
  //     dispatch({
  //       type: AUTH_LOGOUT_OK,
  //     });
  // };
};



//更新redux中的用户信息
export const updateUserInfoAction = (userInfo) => {
  return (dispatch) => {
    // console.log('updateUserInfoAction userInfo,', userInfo);
    //更新保存在本地的用户信息
    storageInfo.saveUserInfo(userInfo);
    dispatch({
      type: AUTH_UPDATE_USER_INFO,
      payload: userInfo, //数据
    });
  };
};

// 更新未读消息数
export const updateUnReadNumberAction = (unReadNumber) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_UNREAD_NUMBER,
      payload: unReadNumber,
    });
  };
};